







































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CSharpObjPattern extends Vue {
  get codeSnippet1 () {
    return `namespace LanthierCodes
{
    public class Pet
    {
        public int Id { get; set; }

        public string Name { get; set; }

        public int Age { get; set; }
    }
}`
  }

  get codeSnippet2 () {
    return `var pet = new Pet()
{
    Id = 123, //Why?
    Name = "Charlie",
    Age = 4
};

var id = PetService.PostPetAsync(pet);`
  }

  get codeSnippet3 () {
    return `namespace LanthierCodes
{
    public class Pet : PetInformation
    {
        public int Id { get; set; }
    }

    public class PetInformation
    {
        public string Name { get; set; }

        public int Age { get; set; }
    }
}`
  }

  get codeSnippet4 () {
    return `namespace LanthierCodes
{
    public interface IPetService
    {
        Task<Pet> GetPetAsync(int id);

        Task<int> PostPetAsync(PetInformation pet);

        Task PutPetAsync(int id, PetInformation pet);

        Task DeletePetAsync(int id);
    }
}`
  }

  get codeSnippet5 () {
    return `var petInfo = new PetInformation()
{
    Name = "Charlie",
    Age = 4
};
var id = await PetService.PostPetAsync(petInfo);

var pet = await PetService.GetPetAsync(id);

pet.Age++;

await PetService.PutPetAsync(id, pet);`
  }
}
